import { Box, Flex, xcss } from '@atlaskit/primitives';

import {
	useGetSelectedCodingAgentAvatarsFromSearchParams,
	useIllustrationViewType,
} from '../../../controllers';
import { BoardColumnsSvg } from '../../assets/board-columns-svg';
import { ProjectSvg, Injections } from '../../assets/project-svg';
import { JfindOnboardIllustrationRefresh } from '../../variant/jfind-onboard-illustration-refresh/jfind-onboard-illustration-refresh';

import { HeaderArrow } from './header-arrow';

export const RightHandSidePageProjectDetails = ({
	projectName,
	isIllustrationRefresh,
}: {
	projectName: string | undefined;
	isIllustrationRefresh?: boolean;
}) => {
	const illustrationViewType = useIllustrationViewType();

	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams();
	const injections: Injections = {
		additionalObject: HeaderArrow,
		svgBody: BoardColumnsSvg({
			columnNames: ['TO DO', 'IN PROGRESS', 'DONE'],
			assignedAgents,
		}),
	};

	if (isIllustrationRefresh) {
		return (
			<Box xcss={illustrationRefreshContainerStyles}>
				<JfindOnboardIllustrationRefresh
					projectName={projectName}
					viewType={illustrationViewType}
				/>
			</Box>
		);
	}

	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="board" injections={injections} />
		</Flex>
	);
};

const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});

const illustrationRefreshContainerStyles = xcss({
	height: '100%',
	overflow: 'hidden',
});
